module.exports = __webpack_public_path__ + "static/media/22.3.7b7424f6.jpg";